export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9502.4e5f1374.jpg";